<ng-container *ngIf="attr">
  <h4 nz-col [nzSpan]="24" [nzMd]="6" class="profile-preview__item-label break-word">{{ attrName }}</h4>
  <p nz-col [nzSpan]="24" [nzMd]="18">
    {{ attrValue }}
  </p>
</ng-container>
